
/**
 * @export
 * @enum {string}
 */
export enum FieldType {
    INTEGER = 'INTEGER',
    BIG_INTEGER = 'BIG_INTEGER',
    DOUBLE = 'DOUBLE',
    BOOLEAN = 'BOOLEAN',
    STRING = 'STRING',
    DATE_TIME = 'DATE_TIME',
    DATE = 'DATE',
    ARRAY = 'ARRAY',
    ARRAY_UNIQUE = 'ARRAY_UNIQUE',
    REFERENCE = 'REFERENCE'
}